import { Paper, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { formatCurrency } from '../../../utils/formatUtils';
import { HorizontalForm } from '../../../common';

const SummaryCard = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  height: '100%',
  width: '30%',
  borderRadius: theme.spacing(1.5),
  border: `1px solid ${theme.palette.divider}`,
}));

const LabelText = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  color: theme.palette.text.secondary,
  marginBottom: theme.spacing(0.5),
}));

const ValueText = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  fontSize: '1.4rem',
  color: theme.palette.primary.main,
}));

const DebtDetailSummary = ({ summary, selectedSummary, isLoading = false }) => {
  const metrics = [
    {
      label: 'Contratos filtrados',
      value: summary?.contracts_total ?? summary?.contracts_on_page ?? 0,
    },
    {
      label: 'Suscriptores filtrados',
      value: summary?.subscribers_total ?? summary?.subscribers_on_page ?? 0,
    },
    {
      label: 'Cuotas vencidas',
      value:
        summary?.total_overdue_installments_total ?? summary?.total_overdue_installments ?? 0,
    },
    {
      label: 'Monto total adeudado',
      value: formatCurrency(
        summary?.total_debt_amount_total ?? summary?.total_debt_amount ?? 0
      ),
      highlight: true,
    },
  ];

  const selectionMetrics = [
    {
      label: 'Cupones seleccionados',
      value: selectedSummary.selectedCoupons ?? 0,
    },
    {
      label: 'Suscriptores seleccionados',
      value: selectedSummary.selectedRecipients ?? 0,
    },
    {
      label: 'Monto a notificar',
      value: formatCurrency(selectedSummary.totalAmount ?? 0),
      highlight: true,
    },
  ];

  return (
    <HorizontalForm
      variant="twoRows"
      sx={{ flex: 1, display: 'flex', gap: 2, mr: 4 }}
    >
      {metrics.map((metric) => (
        <SummaryCard key={metric.label}>
          <LabelText variant="subtitle2">{metric.label}</LabelText>
          <ValueText variant="h6" color={metric.highlight ? 'primary' : 'text.primary'}>
            {isLoading ? 'Calculando...' : metric.value}
          </ValueText>
        </SummaryCard>
      ))}

      {selectionMetrics.map((metric) => (
        <SummaryCard key={metric.label}>
          <LabelText variant="subtitle2">{metric.label}</LabelText>
          <ValueText variant="h6" color={metric.highlight ? 'secondary' : 'text.primary'}>
            {metric.value}
          </ValueText>
        </SummaryCard>
      ))}
    </HorizontalForm>
  );
};

export default DebtDetailSummary;
